import {
  BetMarketIcon,
  FootballIcon,
  JockerIcon,
  KenoIcon,
  LiveCasinoIcon,
  LiveIcon,
  PockerIcon,
  SlotsIcon,
  SlotTournamentIcon,
  SpinGamesIcon, SportTournamentsIcon,
  TableGamesIcon,
  VirtualGamesIcon,
  VoltIcon
} from '../../assets/icons/menu';

export const NavConfig = [
  { label: 'სპორტი', url: '/sport', icon: FootballIcon },
  { label: 'LIVE', url: '/live', icon: LiveIcon },
  { label: 'სპორტის ტურნირები', url: '/page/sport-tournament', icon: SportTournamentsIcon },
  { label: 'ვირტუალური სპორტი', url: '/vSport', icon: VirtualGamesIcon },
  {
    label: 'მაგიდის თამაშები',
    url: '/games',
    icon: TableGamesIcon,
    children: [
      { label: 'ნარდი', url: '/play/nardi' },
    ],
  },
  {
    label: 'სპინ თამაშები',
    url: '/spin-games',
    icon: SpinGamesIcon,
    children: [
      { label: 'სპინ ნარდი', url: '/play/nardi?target=spin' },
    ],
  },
];
